/**
 * fadeElements
 * 
 * This function observes elements with the classes `.fade-in` and `.fade-up`,
 * and adds the `in-view` class to them when they enter the viewport,
 * triggering CSS-based animations (e.g., fade-in effects).
 * It uses IntersectionObserver for efficiency and MutationObserver to handle
 * dynamically added elements. It also runs once on window load to immediately
 * handle any elements already in view.
 */
export function fadeElements() {
  const addInViewClass = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  };

  const intersectionObserver = new IntersectionObserver(addInViewClass, { threshold: 0.1 });

  const observeFadeElements = () => {
    const elements = document.querySelectorAll(".fade-in:not(.in-view), .fade-up:not(.in-view)");
    elements.forEach(el => intersectionObserver.observe(el));
  };

  observeFadeElements();

  const mutationObserver = new MutationObserver(() => {
    observeFadeElements();
  });

  window.addEventListener('load', () => {
    document.querySelectorAll(".fade-in:not(.in-view), .fade-up:not(.in-view)").forEach(el => {
      const rect = el.getBoundingClientRect();
      const inView = rect.top < window.innerHeight && rect.bottom > 0;
      if (inView) {
        el.classList.add('in-view');
      }
    });
  }); 

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

}